import { Vehicle } from 'types/vehicle';
import { AUCTION_TYPES } from 'constants';
import { getHighestBid } from 'utils/vehicle';
import { useOfferAuctionBidsInfo } from 'hooks';
import { useListVehiclesOfferAuction } from './useListVehiclesOfferAuction';

// For AA auctions, prefers the highest offer-auction bid (private-bids/offer flow) over the
// regular auction highest_bid. Alternative auctions keep the existing top_alternative_bid_offer logic.
export const useHighestBid = (vehicle: Vehicle) => {
  const auctionType = vehicle.auction?.type;
  const offerAuction = useListVehiclesOfferAuction(vehicle.id);
  const { highestBidOffer } = useOfferAuctionBidsInfo(offerAuction);

  if (auctionType === AUCTION_TYPES.AUTOAXESS && highestBidOffer?.amount) {
    return { amount: highestBidOffer.amount, id: highestBidOffer.id, bidder: highestBidOffer.bidder };
  }

  const highestBid = getHighestBid(vehicle, auctionType);
  // getHighestBid falls back to a default { bidder: {} } when there's no bid at all — normalize
  // that to no bidder so consumers can rely on falsiness instead of checking amount separately.
  return highestBid.amount > 0 ? highestBid : { ...highestBid, bidder: undefined };
};
